import React from 'react';
import { connect } from 'react-redux';

import { DataLoader } from '../../../components/common';
import { getApplicationsData } from '../../../redux/actions/router';
import { RouterContext } from '../../../types/router';
import { errorLogger } from '../../../utils/error-logger/error-logger';
import { BI_ERRORS } from '../../../utils/statistics/bi-error-logger/bi-errors';

import { ApplicationOverviewContainer } from './application-overview.lazy';

interface RouterParams {
  applicationId: string;
  organizationId: string;
  projectId: string;
}

interface Props {
  router?: RouterContext<RouterParams>;
  getApplicationsData(router: RouterContext<RouterParams>): Promise<void>;
}

export class ApplicationOverviewDataLoader extends React.Component<Props> {
  private loadData(): Promise<void> {
    const { getApplicationsData, router } = this.props;

    if (router) {
      return getApplicationsData(router).catch(
        errorLogger.createLoggingCatcher(
          BI_ERRORS.applications.pageDataLoading,
        ),
      );
    }

    return Promise.reject({});
  }

  public render() {
    return (
      <DataLoader loadData={this.loadData.bind(this)}>
        {(props) => <ApplicationOverviewContainer {...props} />}
      </DataLoader>
    );
  }
}

const mapStateToProps = null;

const mapDispatchToProps = (dispatch) => {
  return {
    getApplicationsData: (context) => dispatch(getApplicationsData(context)),
  };
};

export const ApplicationOverview = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApplicationOverviewDataLoader);
